module.exports = __webpack_public_path__ + "img/MARAVILLOSA.953ee559.png";